export default "mutation createKnowledge($createInfo: KnowledgeCreateRequest) {\n  createKnowledge(createInfo: $createInfo) \n}";